module.exports = __webpack_public_path__ + "static/media/architecturals.1bb1f650.jpg";